import { render, staticRenderFns } from "./index.vue?vue&type=template&id=afd48c98&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=afd48c98&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=afd48c98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd48c98",
  null
  
)

export default component.exports